<template>
	<div class="centerWidth">
		<div class="gaokao">
			<div class="gaokao-nav">
				<span @click="goMyCenter">个人中心 ></span>
				<span @click="goBack">查:专业查询 ></span>
				<span>详情</span>
			</div>
			<section class="widthWhite">
				<article class="xq_head">
					<h6>
						{{ Professional.Name  }}
						<span>【{{ Professional.SubjectName  }}> {{ Professional.ProfessionName  }}】</span>
					</h6>
					<hgroup>
						<p>专业代码: {{ Professional.MajorCode }}</p>
						<p>授予学位:{{ Professional.AwardDegree }}</p>
						<p>学制: {{ Professional.Educational }}</p>
					</hgroup>
				</article>
				<div class="major-tit">
					<p>
						<span>专业介绍</span>
					</p>
				</div>
				<!-- <img src="../../../image/zya.jpg" /> -->

				<ul>
					<li>
						<h6>开设课程:</h6>
						<p>{{ Professional.OfferingCourses }}</p>
					</li>

					<li>
						<h6>培养目标:</h6>
						<p>{{ Professional.TrainingObjectives }}</p>
					</li>

					<li>
						<h6>培养要求:</h6>
						<p>{{ Professional.TrainingRequirements }}</p>
					</li>
				</ul>
			</section>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			tid: 0,
			Professional: {}
		};
	},
	// 加载
	created() {
		this.tid = this.$route.query.tid;
		console.log(this.$route.query);
		this.GetProfessionalDataByType();
	},
	methods: {
		// 个人中心
		goMyCenter() {
			this.$router.push('/myIndex');
		},
		// 返回上一级
		goBack() {
			this.$router.go(-1);
		},
		GetProfessionalDataByType() {
			var that = this;

			that.$api.HtppRequest(
				'SystemData/NewProfessionalTypeDetail?id=' + that.tid,
				'GET',
				{},
				function(res) {
					console.log('获取', res);

					if (res.flag) {
						that.Professional = res.data;
					}
				},
				function(err) {
					console.log(err);
				}
			);
		},
		// 测试
		goTesta() {
			this.$router.push('/gktesta');
		}
	}
};
</script>

<style scoped>
.major-tit{
	width: 100%;
}
.major-tit p span{
	font-size: 16px;
	color: #333;
	font-weight: bold;
	position: relative;
	z-index: 2;
}
.major-tit p{
	position: relative;
}
.major-tit p::after{
	width: 75px;
	height: 7px;
	background-color: #99bac6;
	position: absolute;
	content: '';
	bottom: 0;
	left: 0;
	margin-left: -5px;
	margin-bottom: 2px;
}

.widthWhite {
	margin-bottom: 60px;
}

.widthWhite p {
	font-size: 14px;
	color: #333;
	margin-top: 10px;
	line-height: 26px;
}

.widthWhite h6 {
	font-size: 14px;
	color: #333;
}

.widthWhite ul {
	overflow: hidden;
}

.widthWhite ul li {
	overflow: hidden;
	margin-top: 30px;
	margin-top: 15px;
}

.widthWhite > img {
	display: block;
	width: 100px;
	height: 21px;
	margin-top: 20px;
}

/* widthWhite */

.xq_head p {
	font-size: 14px;
	color: #999;
	margin-top: 15px;
	float: left;
	margin-right: 40px;
}

.xq_head h6 span {
	font-size: 14px;
	font-weight: normal;
	color: #666;
	margin-left: 1em;
}

.xq_head h6 {
	font-size: 16px;
	color: #333;
}

.xq_head {
	background-color: #eaeaea;
	padding: 20px;
	overflow: hidden;
}

.widthWhite {
	padding: 20px;
}

.gaokao {
	width: 100%;
	height: auto;
	overflow: hidden;
}
.gaokao-nav {
	width: 100%;
	display: flex;
	align-items: center;
	padding: 20px 0;
}
.gaokao-nav span {
	font-size: 15px;
	color: #333;
}
.gaokao-nav span:last-child {
	color: #333;
}

.widthWhite {
	padding-bottom: 60px;
}
</style>
